import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { a as addressSchema } from './business-address-schema.js';
import { F as FormController } from './form.js';
import { b as Address } from './Business.js';
import { B as BusinessFormStepV2 } from './business-form-types.js';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils4.js';
import { d as defineCustomElement$5 } from './custom-popper2.js';
import { d as defineCustomElement$4 } from './form-control-error-text2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const LegalAddressFormStepCore = /*@__PURE__*/ proxyCustomElement(class LegalAddressFormStepCore extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.submitted = createEvent(this, "submitted", 7);
        this.stepCompleted = createEvent(this, "form-step-completed", 7);
        this.formLoading = createEvent(this, "formLoading", 7);
        this.errorEvent = createEvent(this, "error-event", 7);
        this.getData = () => {
            this.formLoading.emit(true);
            this.getBusiness({
                onSuccess: (response) => {
                    this.legal_address = new Address(response.data.legal_address || {});
                    this.formController.setInitialValues(Object.assign({}, this.legal_address));
                },
                onError: ({ error, code, severity }) => {
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => this.formLoading.emit(false)
            });
        };
        this.sendData = (onSuccess) => {
            let submittedData;
            this.formLoading.emit(true);
            this.patchBusiness({
                payload: this.patchPayload,
                onSuccess: (response) => {
                    submittedData = response;
                    onSuccess();
                },
                onError: ({ error, code, severity }) => {
                    submittedData = error;
                    this.errorEvent.emit({
                        message: error,
                        errorCode: code,
                        severity: severity
                    });
                },
                final: () => {
                    this.submitted.emit({ data: { submittedData } });
                    this.stepCompleted.emit({ data: submittedData, formStep: BusinessFormStepV2.legalAddress });
                    this.formLoading.emit(false);
                }
            });
        };
        this.inputHandler = (name, value) => {
            this.formController.setValues(Object.assign(Object.assign({}, this.formController.values.getValue()), { [name]: value }));
        };
        this.formController = undefined;
        this.errors = {};
        this.legal_address = {};
        this.getBusiness = undefined;
        this.patchBusiness = undefined;
        this.allowOptionalFields = undefined;
    }
    async validateAndSubmit({ onSuccess }) {
        this.formController.validateAndSubmit(() => this.sendData(onSuccess));
    }
    ;
    get patchPayload() {
        let formValues = new Address(this.formController.values.getValue()).payload;
        return { legal_address: formValues };
    }
    componentWillLoad() {
        this.getBusiness && this.getData();
        this.formController = new FormController(addressSchema(this.allowOptionalFields));
    }
    componentDidLoad() {
        this.formController.errors.subscribe(errors => {
            this.errors = Object.assign({}, errors);
        });
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const legalAddressDefaultValue = this.formController.getInitialValues();
        return (h("form", { key: '0b6da6f38496eed7699b642e3855a085ee004105' }, h("fieldset", { key: '18e56d0ab1c9dfa6f768d16c9f82ce0c203c8cca' }, h("div", { key: '286505d10fdacddf89663069a3f45837fa3f5434', class: "d-flex align-items-center gap-2" }, h("legend", { key: '1632a05fce65e9df5b14e4e61e4f925644b66afe', class: "mb-0" }, "Legal Address of your Business"), h("form-control-tooltip", { key: '2013d53e29f31b923c5304b1d534e8d6edf248c5', helpText: "No PO Boxes." })), h("hr", { key: '95f1dd6e945af35db3b9c107741125c86298d043', class: "mt-2" }), h("div", { key: '33c940f3eb99c742cd7bc26eb30bf2593beee7e7', class: "row gy-3" }, h("div", { key: 'a70c712478ea1c1535dfb7b121a27f73c250737f', class: "col-12" }, h("form-control-text", { key: 'a2295eff889da276b0e7d3c49c0479f684edeab8', name: "line1", label: "Legal Address", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.line1, errorText: (_a = this.errors) === null || _a === void 0 ? void 0 : _a.line1 })), h("div", { key: 'b7c7bbeac63558be4bce0b14857321246c54e03e', class: "col-12" }, h("form-control-text", { key: '67fdffdae07317978b9830af28f2a13d13f49cbe', name: "line2", label: "Address Line 2 (optional)", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.line2, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line2 })), h("div", { key: '2fc87bc9415822b9317e680c6e39065e0410088d', class: "col-12" }, h("form-control-text", { key: 'e3b768d6830c8c6746e22affac093c09239b7b1a', name: "city", label: "City", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.city, errorText: (_c = this.errors) === null || _c === void 0 ? void 0 : _c.city })), h("div", { key: 'b7567c4ca4ecece2927ea79cf0872fe907c45b5b', class: "col-12" }, h("form-control-select", { key: '294fe774b7e621707d800fab28a6efc97f7a0aaf', name: "state", label: "State", options: StateOptions, inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.state, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.state })), h("div", { key: '7dc1741c28d20f006050083bfc371364a3588242', class: "col-12" }, h("form-control-text", { key: '3a38d6a710c5eab2234b40a631b3fbc08f601fea', name: "postal_code", label: "Postal Code", inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.postal_code, errorText: (_e = this.errors) === null || _e === void 0 ? void 0 : _e.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler })), h("div", { key: '8f1a3fab096961e6b0afc09303ee959b263d6677', class: "col-12" }, h("form-control-select", { key: '8f9be74731bafc3377b262779ac6bae0ad374c19', name: "country", label: "Country", options: [{ label: "United States", value: "USA" }], inputHandler: this.inputHandler, defaultValue: legalAddressDefaultValue === null || legalAddressDefaultValue === void 0 ? void 0 : legalAddressDefaultValue.country, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.country,
            // just for now so we skip handling country specificities
            disabled: true }))))));
    }
}, [0, "justifi-legal-address-form-step-core", {
        "getBusiness": [16],
        "patchBusiness": [16],
        "allowOptionalFields": [4, "allow-optional-fields"],
        "formController": [32],
        "errors": [32],
        "legal_address": [32],
        "validateAndSubmit": [64]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-legal-address-form-step-core", "custom-popper", "form-control-error-text", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-legal-address-form-step-core":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, LegalAddressFormStepCore);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { LegalAddressFormStepCore as L, defineCustomElement as d };
